<template>
    <div id="event-calendar-icon" class="tw-rounded tw-bg-white tw-py-1 tw-px-0 tw-border-t-5 tw-text-center tw-border-calendar tw-text-gray-800" :class="size">
        <h4 class="tw-font-bold tw-leading-tigh" v-text="day"></h4>
        <p class="tw-font-light" v-text="month"></p>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'CalendarIcon',

        props: {
            size: {
                type: String,
                default: 'small',
            },

            tEvent: {
                default: false,
            },

            format: {
                type: String,
                default: 'MMMM DD, YYYY',
            },
        },

        computed: {
            day() {
                if (this.tEvent !== false) {
                    return moment(this.tEvent.start_date, this.format).format('D');
                }

                return moment().format('D');
            },

            month() {
                if (this.tEvent !== false) {
                    return moment(this.tEvent.start_date, this.format).format('MMM').slice(0, -1).toUpperCase();
                }

                return moment().format('MMM').slice(0, -1).toUpperCase();
            },
        },
    };
</script>

<style lang="scss" scoped>
    #event-calendar-icon {
        box-shadow: 0 1px 3px #00000029;

        &.xs {
            width: 38px;

            h4 {
                @apply tw-text-base;
            }

            p {
                @apply tw-text-sm;
            }
        }

        &.small {
            width: 43px;

            h4 {
                @apply tw-text-xl;
            }

            p {
                @apply tw-text-base;
            }
        }

        &.large {
            width: 55px;

            h4 {
                @apply tw-text-3xl;
            }

            p {
                @apply tw-text-lg;
            }
        }

        &.xlarge {
            width: 60px;

            h4 {
                @apply tw-text-4xl;
            }

            p {
                @apply tw-text-lg;
            }

        }
    }
</style>